import { base } from 'antd-mobile/cjs/locales/base'
import { mergeLocale } from 'antd-mobile/cjs/utils/merge-locale'

const tr = mergeLocale(base, {
  locale: 'Türkçe',
  common: {
    confirm: 'Onayla',
    cancel: 'İptal',
    loading: 'Yükleniyor',
    close: 'Kapat',
  },
  Calendar: {
    markItems: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'],
    renderYearAndMonth: (yıl: number, ay: number) => `${yıl}/${ay}`,
  },
  Cascader: {
    placeholder: 'Seç',
  },
  Dialog: {
    ok: 'Tamam',
  },
  DatePicker: {
    tillNow: 'Şimdiye kadar',
  },
  ErrorBlock: {
    default: {
      title: 'Üzgünüz, bir hata oluştu',
      description: 'Lütfen bir dakika bekleyin ve tekrar deneyin',
    },
    busy: {
      title: 'Üzgünüz, yüklenmiyor',
      description: 'Sayfayı yenilemeyi deneyin',
    },
    disconnected: {
      title: 'Ağ meşgul',
      description: 'Sayfayı yenilemeyi deneyin',
    },
    empty: {
      title: "Bu bulunamadı...",
      description: 'Yeni bir arama denemek ister misiniz?',
    },
  },
  InfiniteScroll: {
    noMore: 'Daha fazla yok',
    failedToLoad: 'Yükleme başarısız',
    retry: 'Tekrar dene',
  },
  Input: {
    clear: 'Temizle',
  },
  Mask: {
    name: 'Maske',
  },
  Modal: {
    ok: 'Tamam',
  },
  PullToRefresh: {
    pulling: 'Yenilemek için aşağı kaydırın',
    canRelease: 'Hemen yenilemeyi bırakın',
    complete: 'Başarıyla yenilendi',
  },
  SearchBar: {
    name: 'Arama Çubuğu',
  },
  Slider: {
    name: 'Kaydırıcı',
  },
  Stepper: {
    decrease: 'Azalt',
    increase: 'Artır',
  },
  Switch: {
    name: 'Anahtar',
  }
})

export default tr
